export const TOAST_TIMEOUT = 3000;
export const INFINITE_SHIPMENTS = 999;
export const UNLIMITED_MONTH_CYCLE = 12;
